var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "help" } }, [
    _c("div", { staticClass: "help-warp" }, [
      _c(
        "ul",
        { staticClass: "item" },
        _vm._l(_vm.helpList, function(item) {
          return _c("li", { key: item.type_id, staticClass: "help-list" }, [
            _c("h1", [_vm._v(_vm._s(item.type_name))]),
            _c(
              "div",
              { staticClass: "list" },
              _vm._l(item.children, function(first) {
                return _c(
                  "nuxt-link",
                  {
                    key: first.type_id,
                    attrs: { to: "/trait/help/" + first.type_id }
                  },
                  [_vm._v(_vm._s(first.type_name))]
                )
              }),
              1
            )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1105d5c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1105d5c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/trait/help/index.vue
// module id = h/r4
// module chunks = 7